/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { Grid, Typography, Box } from '@mui/material';
import { themes, fonts } from '../../../../common/themes/themes';
import moment from 'moment';
import _ from 'lodash';
import emptyIcon from '../../../../assets/images/empty_icon.svg';
import './EventBox.css';
import UpcomingBirthdayBox from '../../../../common/components/UpcomingBirthdayBox/UpcomingBirthdayBox';
import { useTranslation } from 'react-i18next';
interface eventList {
  events: any;
}

const EventsBox = ({ events }: eventList) => {
  const { t, i18n } = useTranslation();

  const getColors = (ind: any) => {
    const allColors = ['#4CAF50', '#FFB400', '#2196F3'];
    const bgColors = ['#E9F3E9', '#FBF3E1', '#E4F0FA'];

    return { color: allColors[ind], bgColor: bgColors[ind] };
  };
  return (
    <div
      style={{
        marginTop: '20px',
        marginLeft: '1em',
      }}
    >
      {events?.length > 0 ? (
        events?.map((event: any, index: number) => {
          return event?.notification_type != t('Birthday') ? (
            _.map(event.notification_data, (data) => {
              if (event.notification_type == 'Holidays') {
                return (
                  <div>
                    {_.map(
                      event.notification_data,
                      (event: any, index: number) => {
                        const is_Color: any = getColors(index);
                        const holiday_date: any = new Date(event?.fromDate);
                        const today_date: any = new Date();
                        const diffTime = Math.abs(holiday_date - today_date);
                        const diffDays = Math.ceil(
                          diffTime / (1000 * 60 * 60 * 24),
                        );

                        return (
                          <div key={index}>
                            <Box className="holiday-box">
                              <Grid container spacing={2}>
                                <Grid
                                  item
                                  xs={12}
                                  style={{
                                    display: 'flex',
                                  }}
                                >
                                  <Grid item xs={4}>
                                    <Box
                                      style={{
                                        height: '60px',
                                        width: '60px',
                                        backgroundColor: is_Color.bgColor,
                                        borderRadius: '10px',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        display: 'flex',
                                        flexDirection: 'column',
                                      }}
                                    >
                                      <Typography
                                        style={{
                                          fontFamily: fonts.fontFamily,
                                          fontSize: '18px',
                                          fontWeight: 'bold',
                                          color: is_Color.color,
                                        }}
                                      >
                                        {moment(event?.fromDate).format('DD')}
                                      </Typography>
                                      <Typography
                                        style={{
                                          fontFamily: fonts.fontFamily,
                                          fontSize: '18px',
                                          fontWeight: 'bold',
                                          color: is_Color.color,
                                        }}
                                      >
                                        {i18n.language == 'en'
                                          ? moment(event?.fromDate).format(
                                              'MMM',
                                            )
                                          : t(
                                              moment(event?.fromDate).format(
                                                'MMMM',
                                              ),
                                            )}
                                      </Typography>
                                    </Box>
                                  </Grid>
                                  <Grid item xs={8}>
                                    <Box
                                      style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        justifyContent: 'center',
                                        height: '60px',
                                      }}
                                    >
                                      <Typography
                                        style={{
                                          fontFamily: fonts.fontFamily,
                                          fontSize: fonts.subtitle,
                                          color: is_Color.color,
                                        }}
                                      >
                                        {t(
                                          moment(event?.fromDate).format(
                                            'dddd',
                                          ),
                                        )}
                                      </Typography>
                                      <Typography
                                        style={{
                                          fontFamily: fonts.fontFamily,
                                          fontSize: fonts.title,
                                          color: themes.darkBlue,
                                          fontWeight: 'bold',
                                        }}
                                      >
                                        {event?.name}
                                      </Typography>
                                      <Typography
                                        style={{
                                          fontFamily: fonts.fontFamily,
                                          fontSize: fonts.subtitle,
                                          color: themes.greySubtitle,
                                        }}
                                      >
                                        {diffDays} {t('days left')}
                                      </Typography>
                                    </Box>
                                  </Grid>
                                </Grid>
                              </Grid>
                            </Box>
                          </div>
                        );
                      },
                    )}
                  </div>
                );
              } else {
                if (data?.name === 'Joseph Solomon Daniel') {
                  return;
                }
                return (
                  <div key={index}>
                    <UpcomingBirthdayBox
                      date={data?.date}
                      name={
                        event.notification_type == 'Work Anniversary'
                          ? data?.name
                          : data?.first_name + ' ' + data?.last_name
                      }
                      pic={data?.pic}
                      event_name={event?.notification_type}
                    />
                  </div>
                );
              }
            })
          ) : (
            <div>
              {_.map(event.notification_data, (data) => {
                const date = new Date(data?.date);
                const todayDate = new Date();
                const _date = moment(date).format('DD-MM-YYYY');
                const _todayDate = moment(todayDate).format('DD-MM-YYYY');
                if (_date != _todayDate && data?.name !== 'Joseph Solomon Daniel') {
                  return (
                    <UpcomingBirthdayBox
                      date={data?.date}
                      name={data?.name}
                      pic={data?.pic}
                    />
                  );
                }
              })}
            </div>
          );
        })
      ) : (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img src={emptyIcon} />
          <Typography
            style={{
              fontFamily: fonts.fontFamily,
              color: themes.greyDefault_500,
              fontSize: fonts.title,
            }}
          >
            {t('Empty')}
          </Typography>
        </div>
      )}
    </div>
  );
};

export default EventsBox;
